import React from "react"
import { defineMessages, FormattedMessage, injectIntl } from "react-intl"
import { Intl } from "../../state/helpers/IntlProps"

type Props = {
    onChange: () => void
    object: string
    intl: Intl
}

const messages = defineMessages({
    "invoices": {
        id: "bulk.operation.object.invoices",
        defaultMessage: "invoices and credit memos"
    },
    "orders": {
        id: "bulk.operation.object.orders",
        defaultMessage: "orders"
    },
    "documents": {
        id: "bulk.operation.object.documents",
        defaultMessage: "documents",
    },
    "contacts": {
        id: "bulk.operation.object.contacts",
        defaultMessage: "contacts",
    },
    "companies": {
        id: "bulk.operation.object.companies",
        defaultMessage: "companies",
    },
    
    

})

const BulkDeleteComponent = (props: Props) => {

    return (
        <div>
            <div className={"row d-flex justify-content-center"}>
                <div className={"col-8 pb-4 text-center"}>
                    <em>
                        <FormattedMessage
                            id="bulk.operations.deletes.description"
                            defaultMessage="All {object} selected will be deleted. This action is irreversible."
                            values={{
                                object: messages[props.object] ?
                                    props.intl.formatMessage(messages[props.object]) :
                                    props.intl.formatMessage(messages["documents"])
                            }} />
                    </em>
                </div>
            </div>
        </div>
    )
}

export default injectIntl(BulkDeleteComponent)


// WEBPACK FOOTER //
// ./src/bulk/operations/BulkDeleteComponent.tsx